module.exports = __webpack_public_path__ + "img/1918.32ec31f1.jpg";